import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";

import Edit from "./edit";
import Save from "./save";

registerBlockType("hfc-blocks/list-item", {
  title: __("List Item", "header-footer-customizer"),
  icon: "text-page",
  parent: ["hfc-blocks/icon-list"],
  edit: Edit,
  save: Save
});